import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/config';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="text-xl font-heading font-bold whitespace-nowrap cursor-pointer">
                <i className="ri-gamepad-line mr-2"></i>
                {siteConfig.name}
              </Link>
              <p className="mt-3 text-sm text-secondary-400 leading-relaxed">
                {siteConfig.tagline}——为您提供最全面的游戏攻略与深度内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                {siteConfig.navItems.map((item) => (
                  <Link
                    key={item.href}
                    to={item.href}
                    className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门攻略</h4>
              <div className="flex flex-col gap-2">
                <Link to="/article/goblin-cave-beginner-complete-guide" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">新手完全入门指南</Link>
                <Link to="/article/goblin-cave-equipment-tier-list" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">装备天梯榜</Link>
                <Link to="/article/goblin-cave-boss-dragon-king" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">最终BOSS攻略</Link>
                <Link to="/article/goblin-cave-lore-deep-dive" className="text-sm text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">世界观全解析</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2 text-sm text-secondary-400">
                <p><i className="ri-mail-line mr-2"></i>{siteConfig.email}</p>
                <div className="flex gap-3 mt-2">
                  <a href={siteConfig.social.bilibili} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors cursor-pointer" aria-label="Bilibili">
                    <i className="ri-bilibili-line"></i>
                  </a>
                  <a href={siteConfig.social.weibo} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors cursor-pointer" aria-label="Weibo">
                    <i className="ri-weibo-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500">
              &copy; {new Date().getFullYear()} {siteConfig.name}. 本站为游戏攻略内容分享平台，所有内容仅供玩家参考。
            </p>
            <div className="flex gap-4 text-xs text-secondary-500">
              <Link to="/about" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}